import Vue from "vue";
import Stringer from "../packages/stringer/src/Stringer";

export default class FormErrors {
	constructor() {
		this.errors = {};
	}

	has(field, ...indexes) {
		return _.has(this.errors, new Stringer(field).replaceArray("*", indexes).value);
	}

	hasAny(fields) {
		return _.filter(Object.keys(this.errors), error => {
			return fields.indexOf(error) > -1;
		}).length > 0;
	}

	any() {
		return this.numberOfErrors() > 0;
	}

	numberOfErrors() {
		return Object.keys(this.all()).length;
	}

	all() {
		let all = {};

		(function recurse(obj, current) {
			for (let key in obj) {
				let value = obj[key];
				let newKey = (current ? current + "." + key : key);  // joined key with dot
				if (value && typeof value === "object") {
					recurse(value, newKey);  // it's a nested object, so do it again
				} else {
					all[newKey] = value;  // it's not an object, so set the property
				}
			}
		})(this.errors);

		return all;
	}

	first(field, ...indexes) {
		field = new Stringer(field).replaceArray("*", indexes).value;
		console.log("first", field);
		return _.find(this.all(), (error, key) => {
			console.log(error, key);
			return key.startsWith(field);
		});
	}

	get(field, ...indexes) {
		return _.get(this.errors, new Stringer(field).replaceArray("*", indexes).value);
		// let key = field;
		// if (index) {
		// 	key = key + "." + index;
		// }
		// return _.get(this.errors, key);
		// let errors = _.pickBy(this.errors, (error, key) => {
		// 	return key.startsWith(field);
		// });
		// if (field === "data.landTaxCalculation.property_price") {
		// 	console.log(this.errors, errors);
		// }
		//
		// if (!Object.values(errors).length) {
		// 	return null;
		// }
		//
		// errors = _.mapValues(errors, (error) => {
		// 	if (Array.isArray(error)) {
		// 		return error[0];
		// 	}
		// 	return error;
		// });
		//
		// if (index) {
		// 	field = field + "." + index;
		// }
		//
		// if (_.has(errors, field)) {
		// 	return errors[field];
		// }
		//
		// let parts = field.split(".");
		// if (parts.length) {
		// 	parts = parts.slice(0, -1);
		// }
		// field = parts.join(".");
		//
		// return _.mapKeys(errors, (error, key) => {
		// 	return key !== field ? key.replace(field, "").replace(/^\./, "").replace(/\.$/, "") : key;
		// });
	}

	record(errors) {
		this.errors = {};
		_.each(errors, (error, key) => {
			_.set(this.errors, key, error[0]);
		});
	}

	remove(key) {
		Vue.delete(this.errors, key);
	}

	clear() {
		this.errors = {};
	}
}
